{
  "public/": {
    "samples/": {
      "arithmetic-ops.txt": {
        "size": 119
      },
      "boolean-logic.txt": {
        "size": 99
      },
      "conditional-branch.txt": {
        "size": 152
      },
      "console-output.txt": {
        "size": 207
      },
      "current-time.txt": {
        "size": 44
      },
      "delay-demo.txt": {
        "size": 63
      },
      "fetch-text.txt": {
        "size": 55
      },
      "fibonacci.txt": {
        "size": 169
      },
      "fizzbuzz.txt": {
        "size": 169
      },
      "for-range-cats.txt": {
        "size": 84
      },
      "lambda-and-apply.txt": {
        "size": 152
      },
      "match-replace.txt": {
        "size": 137
      },
      "pi-variable.txt": {
        "size": 177
      },
      "readline-prompt.txt": {
        "size": 98
      },
      "reduce-sum.txt": {
        "size": 89
      },
      "set-ops-basic.txt": {
        "size": 211
      },
      "set-ops-by.txt": {
        "size": 343
      },
      "set-ops-distinct.txt": {
        "size": 135
      },
      "set-relations-basic.txt": {
        "size": 317
      },
      "set-relations-by.txt": {
        "size": 507
      },
      "string-interpolation.txt": {
        "size": 198
      },
      "window-alert.txt": {
        "size": 94
      }
    }
  }
}
